import * as React from "react";
const Term = (props) => {
  const { label, children } = props;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "text-bold" }, label), children);
};
export {
  Term
};
